<template>
    <div class="flex justify-center bg-cover video-cover" :style="`background-image:url(${coverImage})`">

        <div class="self-center text-center modal-button">
            <button class="bg-white rounded-full video-play" @click="toggleModal"><div class="arrow-right"></div></button>
        </div>


        <div class="animated fixed relative pin-b pin-t pin-x pin-y align-top m-auto justify-end justify-center p-8 bg-white md:rounded w-full md:h-auto flex flex-col modal-video" v-if="open">
            <button @click="toggleModal">Close</button>
            <div class="player">
                <youtube-playlist :videos="formattedVideos"></youtube-playlist>
            </div>
        </div>

    </div>
</template>

<script>
    import { map } from 'underscore';

    export default {

        name: 'YouTubeModal',

        props: ['videos', 'cover-image'],

        data() {
            return {
                open: false,
            }
        },

        methods: {

            toggleModal() {
                this.open = !this.open;

                if (this.open) {
                    jQuery(document).one('keydown', ({ key }) => {
                        if (key === 'Escape') {
                            this.toggleModal();
                        }
                    });
                }
            },

        },

        computed: {

            formattedVideos() {
                return map(this.videos, video => {
                    return  {
                        url: video,
                        config: {
                            rel: 0,
                            autoplay: 1,
                            color: 'white',
                            controls: 1,
                        },
                    };
                })
            },

        }

    }
</script>

<style scoped lang="scss">

    .modal-video {
        position: fixed;
        z-index: 999;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,0.8);
    }

    .player {
        max-width: 100%;
        height: auto;
    }

    .video-cover {
        height: 240px;
        background-position: 50%;
        .arrow-right {
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 35px solid #161b4e;
            margin-left: 30%;
        }
        @screen md {
            height: 320px;
        }

        @screen lg {
            height: 620px;
        }

        .modal-button {

            .video-play {
                height: 75px;
                width: 75px;

                img {
                    display: block;
                    margin: 0 auto;
                    transform: translate(5px, 1px);
                }
            }
        }
    }

</style>

<style lang="scss">
    .lg\:w-1\/2 .video-cover {
        height: 350px
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/YouTubeModal.vue